import React from 'react';
import styles from './ConfirmarModal.module.css';
import useEsc from '../../hooks/useEsc';

function ConfirmarModal({ titulo, mensagem, textoConfirmar = 'Confirmar', confirmando, erro, onConfirmar, onCancelar, perigo }) {
  useEsc(onCancelar);
  return (
    <div className={styles.overlay}>
      <div className={styles.modal} onClick={e => e.stopPropagation()}>
        <h2 className={styles.titulo}>{titulo}</h2>
        <p className={styles.mensagem}>{mensagem}</p>
        {erro && <p className={styles.erro}>{erro}</p>}
        <div className={styles.acoes}>
          <button className={styles.btnCancelar} onClick={onCancelar} disabled={confirmando} type="button">Cancelar</button>
          <button
            className={`${styles.btnConfirmar} ${perigo ? styles.btnPerigo : ''}`}
            onClick={onConfirmar}
            disabled={confirmando}
            type="button"
          >
            {confirmando ? 'Aguarde...' : textoConfirmar}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmarModal;
